import PeeringConfig from '../../config/PeeringConfig';

export default class KernelConfig extends PeeringConfig {
  readonly binaryLocation: string;
  readonly runtimeLocation: string;
  readonly isPath: boolean;

  constructor(obj?: KernelConfig) {
    super(obj);
    this.binaryLocation = (obj && obj.binaryLocation) || '';
    this.runtimeLocation = (obj && obj.runtimeLocation) || '';
    this.isPath = (obj && obj.isPath) || false;
  }
}
